import React, { useState, useEffect } from 'react';
import './PointHistory.css';
import { useNavigate } from 'react-router-dom';
import en from '../locales/eng.json';
import th from '../locales/th.json';
import CONFIG from '../config';

import getProfileImage from '../utils/getProfileImage';

function PointHistory() {
  const navigate = useNavigate();
  const storedData = localStorage.getItem('userData');
const [userData, setUserData] = useState(null);
const [language, setLanguage] = useState(() => {
  return localStorage.getItem('language') || 'TH';
});
const [t, setT] = useState(language === 'EN' ? en : th);
const [pointHistory, setPointHistory] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
const profileImage = getProfileImage()

useEffect(() => {
  localStorage.setItem('language', language);
  setT(language === 'EN' ? en : th);
}, [language]);

useEffect(() => {
  const fetchPointHistory = async () => {
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/linepoint/history?line_user_id=`+ localStorage.getItem('line_user_id'));
      const result = await res.json();
      if (result.content && result.content.data) {
        const formatted = result.content.data.map(item => ({
          name: item.details,
          type: item.status,
          amount: (item.status === 'Earned' ? '+' : '-') + item.point.toLocaleString(),
          color:
            item.status === 'Earned' ? '#00B2B8' :
            item.status === 'Redeemed' ? '#F44336' :
            item.status === 'Expired' ? '#F44336' :
            '#999999'
        }));
        setPointHistory(formatted);
      }
    } catch (error) {
      console.error("Error fetching point history:", error);
    }
  };

  fetchPointHistory();
}, []);

const translations = {
  EN: en,
  TH: th,
};

const translateText = (text) => {
  
  const currentLocale = translations[localStorage.getItem('language')];

  // 1. Direct lookup for common phrases (e.g., "Hi", "Earned")
  if (currentLocale && currentLocale.common_phrases && currentLocale.common_phrases[text]) {
    return currentLocale.common_phrases[text];
  }

  // 2. Specific status type translations
  const statusTranslations = {
    EN: {
      'Earned': 'Earned',
      'Redeemed': 'Redeemed',
      'Void Earn': 'Void Earn',
      'Register': 'Registered',
      'Expired': 'Expired', // Added from previous example, ensure it's in your JSON too
      'Pending': 'Pending', // Added from previous example, ensure it's in your JSON too
    },
    TH: {
      'Earned': 'ได้รับคะแนน',
      'Redeemed': 'แลกคะแนน',
      'Void Earn': 'คืนคะแนน',
      'Register': 'ลงทะเบียน',
      'Expired': 'หมดอายุ', // Added from previous example
      'Pending': 'รอดำเนินการ', // Added from previous example
    }
  };

  if (statusTranslations[language] && statusTranslations[language][text]) {
    return statusTranslations[language][text];
  }


  const thaiToEnglishPrefixes = {
    'แลกคูปอง:': 'Redeemed Coupon:',
    'ได้รับคูปอง:': 'Earned Coupon:',
  };

  for (const originalThaiPrefix in thaiToEnglishPrefixes) {
    if (text.startsWith(originalThaiPrefix)) {
      if (language === 'EN') {
        const translatedPrefix = thaiToEnglishPrefixes[originalThaiPrefix];
        return translatedPrefix + text.substring(originalThaiPrefix.length);
      } else if (language === 'TH') {
        return text;
      }
    }
  }


  return text;
};




useEffect(() => {
  const fetchUserData = async () => {
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/lineuser/fetch_user_data?line_user_id=`+ localStorage.getItem('line_user_id'));
      const result = await res.json();

      if (result?.content?.data) {
        setUserData(result.content.data);
      } else {
        throw new Error("Invalid user data format");
      }
    } catch (e) {
      console.error("Failed to fetch user data:", e);
      navigate('/'); // Navigate away if error
    }
  };

  fetchUserData();
}, [navigate]);

  return (
    <div style={{ backgroundColor: ' #FFFFFF'}}>
      <div className="point-header-gradient">
  <img onClick={() => navigate('/')} src="/assets/logo-ujoy.png" alt="logo" className="logo-ujoy" />
  <div className="right-section">
  <div className="lang-selector">
  <button
    className={`lang-button ${language === 'TH' ? 'active' : ''}`}
    onClick={() => setLanguage('TH')}
  >
    TH
  </button>
  |
  <button
    className={`lang-button ${language === 'EN' ? 'active' : ''}`}
    onClick={() => setLanguage('EN')}
  >
    EN
  </button>
</div>

    {/* <img src="/assets/avartar.png" alt="avatar" className="profile-avatar" /> */}
            {showMenu ? 
          <div >
           
 {showMenu && (
  <>
   <img
  onClick={() => navigate('/profile')}
  src="/assets/mascot-full.png"
  alt="avatar"
  style={{ position: 'relative', zIndex: 9998 }} // ADD position
/>
    <div className="menu-overlay" onClick={() => setShowMenu(false)}></div>
    <div className="menu-popup-wrapper">
      <div className="menu-popup">
        <div className="menu-item" onClick={() => { navigate('/my-coupon'); setShowMenu(false); }}>
          <img src="/assets/icon-coupon.png" alt="coupon" />
          <span>คูปองของฉัน</span>
        </div>
        <div className="menu-item" onClick={() => { navigate('/point-redeem'); setShowMenu(false); }}>
          <img src="/assets/icon-redeem.png" alt="redeem" />
          <span>แลกคะแนน</span>
        </div>
        <hr className="dashed-line" />
        <div className="menu-item" onClick={() => { navigate('/point-history'); setShowMenu(false); }}>
          <img src="/assets/icon-points.png" alt="points" />
          <span>คะแนนสะสม</span>
        </div>
        <hr className="dashed-line" />
      </div>
    </div>
  </>
)}


  </div>
  : <div><img
  onClick={() => navigate('/profile')}
  src={
    userData?.line_image_url
      ? userData.line_image_url
      : "/assets/avartar.png"
  }
  alt="avatar"
  className="profile-avatar"
/></div>}

  </div>
    </div>

    <div className="point-header-bar">
    <button className="back-button" onClick={() => navigate(-1)}>
  <img src="/assets/arrow_back.png" alt="Back" className="back-icon" />
</button>
  <span className="point-header-title">{t.point_history.point_history}</span>
</div>

<div className="points-summary-section">
  <div className="points-summary-left">
    <div className="points-title">{t.point_history.present_points}</div>

    <div className="points-balance">
      <span className="points-amount">{userData?.point?.toLocaleString()}</span>
      <img src="/assets/coin.png" alt="coin" className="coin-icon" />
    </div>

    <div className="points-expiry-text-history">{userData?.point?.toLocaleString()} {t.point_history.points}</div>
  </div>

  <button className="my-coupon-button" onClick={() => navigate('/my-coupon')}>
    <img src="/assets/confirmation_number.png" alt="icon" className="coupon-icon" />
    {t.point_history.my_coupon}
  </button>
</div>

<hr className="dashed-line-gray" />

<div className="transaction-history">
  {pointHistory.map((item, idx) => (
    <div className="transaction-row" key={idx}>
      <div>
        <p className="transaction-title" style={{ color: item.color }}>
             {translateText(item.name)}
          </p>

        <p className="transaction-sub">{translateText(item.type)}</p>
      </div>
      <div className="transaction-amount" style={{ color: item.color }}>
        {item.amount}
      </div>
    </div>
  ))}
</div>



    </div>
  );
}

export default PointHistory;
